import React from 'react'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward'

import Button from 'components/Form/Button'
import {
    BackButton,
    BackLabel,
    Category,
    CategoryDot,
    CategoryText,
    DetailArticle,
    DetailAside,
    DetailBody,
    DetailHeader,
    DetailImage,
    DetailLayout,
    DetailMeta,
    DetailMetaRelative,
    DetailTitle,
    DetailTopbar,
    Paragraph,
    Paragraphs,
} from './styled'

export default function NotificationDetailContent({ backLabel, notification, onBack, onGoToAction, openLabel }) {
    return (
        <DetailArticle>
            <DetailTopbar>
                <BackButton aria-label={backLabel} onClick={onBack}>
                    <ArrowBackIcon fontSize="small" />
                    <BackLabel>{backLabel}</BackLabel>
                </BackButton>
            </DetailTopbar>

            <DetailHeader>
                <Category>
                    <CategoryDot />
                    <CategoryText>{notification.category}</CategoryText>
                </Category>
                <DetailTitle>{notification.title}</DetailTitle>
            </DetailHeader>

            {notification.imageUrl ? <DetailImage alt="" src={notification.imageUrl} /> : null}

            <DetailLayout>
                <DetailBody>
                    <Paragraphs>
                        {notification.body.map(item => <Paragraph key={item.key}>{item.text}</Paragraph>)}
                    </Paragraphs>
                </DetailBody>

                <DetailAside>
                    {notification.formattedDate ? (
                        <DetailMeta dateTime={notification.createdAt || undefined}>{notification.formattedDate}</DetailMeta>
                    ) : null}
                    {notification.relativeTime ? <DetailMetaRelative>{notification.relativeTime}</DetailMetaRelative> : null}

                    {notification.url ? (
                        <Button
                            color="blue"
                            nospace
                            startIcon={<ArrowOutwardIcon />}
                            width="fit-content"
                            onClick={onGoToAction}
                        >
                            {notification.ctaLabel || openLabel}
                        </Button>
                    ) : null}
                </DetailAside>
            </DetailLayout>
        </DetailArticle>
    )
}
